import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ClientMapper } from "./client.mapper";
import { environment } from "environments/environment";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";
import { Client, ClientStats } from "./client.model";
import { Location } from "../location/location.model";
import { LocationMapper } from "../location/location.mapper";
import { ClientViesData } from "./client-vies-data.model";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class ClientRepository extends CrudAbstractRepository {
  getMapper(): any {
    return ClientMapper.map;
  }

  getEndpoint(): string {
    return "client";
  }

  public getStats(): Observable<ClientStats> {
    return this.http.get<ClientStats>(`${environment.apiUrl}/client/stats`);
  }

  public checkTin(tin: string): Observable<ClientViesData> {
    return this.http.get<ClientViesData>(
      `${environment.apiUrl}/client/tin/check/${tin}`,
    );
  }

  public merge(mainClient: Client, clients: Client[]): Observable<Client> {
    const clientIds = [];
    clients.forEach((client) => {
      if (client.getId() !== mainClient.getId()) {
        clientIds.push(client.getId());
      }
    });

    return this.http
      .post(`${environment.apiUrl}/client/${mainClient.getId()}/merge`, {
        clients: clientIds,
      })
      .pipe(map((response) => ClientMapper.map(response)));
  }

  public generateExportFile(): Observable<Blob> {
    return this.http
      .get(`${environment.apiUrl}/client/export`, {
        responseType: "blob",
      })
      .pipe(
        map((res) => new Blob([res], { type: "application/vnd.ms-excel" })),
      );
  }

  public getLocations(
    client: Client,
    variants: string[] | null = null,
  ): Observable<Location[]> {
    let params = new HttpParams();
    if (variants && variants.length) {
      variants.forEach((variant) => {
        params = params.append("criteria[variants][]", variant);
      });
    }

    return this.http
      .get<any>(`${environment.apiUrl}/client/${client.getId()}/locations`, {
        params: params,
      })
      .pipe(
        map((response) => {
          const originLocations: Location[] = response["originLocations"].map(
            LocationMapper.map,
          );
          const destinationLocations: Location[] = response[
            "destinationLocations"
          ].map(LocationMapper.map);
          const qol: Location[] = response["quoteOriginLocations"].map(
            LocationMapper.map,
          );
          const qdl: Location[] = response["quoteDestinationLocations"].map(
            LocationMapper.map,
          );

          return [...originLocations, ...destinationLocations, ...qol, ...qdl];
        }),
      );
  }
}
